import {Injectable} from "@angular/core";
import {Observable} from "rxjs/Rx";
import {CustomHttpService} from "./CustomHttp.service";
import {API_CONSTANTS} from "../common/constant/ApiConstants";
import {Login} from "../shared/Login";
import {ResponseResult} from "../shared/ResponseResult";

@Injectable()
export class InformationService {
    constructor(private _customHttpService : CustomHttpService) {}

    verifyEmail(encodedStr : string) : Observable<any> {
        return this._customHttpService.get(API_CONSTANTS.VERIFY_EMAIL +"?key=" + encodedStr);
    }

    setNewPassword(login: Login) : Observable<any> {
      return this._customHttpService.post(API_CONSTANTS.SET_NEW_PASSWORD, JSON.stringify(login));
    }

    forgotPasswordMail(login: Login) : Observable<any> {
      return this._customHttpService.post(API_CONSTANTS.FORGOT_PASSWORD_EMAIL, JSON.stringify(login));
    }

    forgotPasswordAccount(encodedStr : string) : Observable<ResponseResult<Login>> {
      return this._customHttpService.get(API_CONSTANTS.FORGOT_PASSWORD_ACCOUNT +"?key=" + encodedStr);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/information.service.ts